import styled, { css } from 'styled-components';
import { Button, Box, Text, AvatarStyled, Avatar } from '@bechtel/gds';
import { OwnerActionButtonProps } from './types';

export const OwnerListContainerStyled = styled.div`
  ${({ theme }) => css`
    margin-right: ${theme.spacings[600]};
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateY(100%);
  `}
`;
export const OwnerActionButtonStyled = styled(Button)`
  ${({ theme }) => css`
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    background-color: ${theme.colors.bechtel.blue[800]};
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14);
    ${(props: OwnerActionButtonProps) =>
      props.secondaryOwnersVisible &&
      css`
        background-color: ${theme.colors.bechtel.blue[900]};
      `}
  `}
  &:focus {
    box-shadow: none;
  }
`;

export const OwnerStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  p: { sm: '400' },
})`
  position: relative;
`;

export const OwnerListOuterStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  position: relative;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
  overflow: hidden;
  border-bottom-left-radius: ${({ theme }) => theme.radii[200]};
  background-color: ${({ theme }) => theme.colors.bechtel.blue[900]};
`;

export const AddCrewStyled = styled(AvatarStyled)`
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.bechtel.blue[700]};
    border-color: ${theme.colors.bechtel.blue[700]};
    border-width: 1px;
  `};
`;

export const MultiUserIcon = styled(AvatarStyled)`
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.bechtel.blue[700]};
    color: ${theme.colors.white};
    border-color: ${theme.colors.white};
    border-width: 1px;
  `};
`;
export const AvatarRegularStyled = styled(Avatar)`
  border-width: 1px;
`;

export const OwnerNameStyled = styled(Box).attrs({ mt: { sm: '300' } })`
  & > * {
    ${({ theme }) => css`
      width: 96px;
      padding-bottom: ${theme.spacings[100]};
      text-align: center;
    `}
  }
`;
